import { defineStore } from 'pinia';

export const useAiSettingsStore = defineStore('ai-settings', () =>
{
    const aiSettings = ref<AiSettings>(defaultAiSettings());
    const aiEnabled = computed(() => aiSettings.value.isEnabled);

    const aiProviders = computed(() => aiSettings.value.aiProviders);
    const aiProviderOptions = computed<Option[]>(() =>
        aiProviders.value.map(config => ({
            value: config.name,
            text: config.label
        }))
    );

    const aiModels = computed(() => aiSettings.value.aiModels);
    const aiModelOptions = computed(() => (type?: string): Option[] =>
        aiModels.value
            .filter(config => !type || config.type === type)
            .map(config => ({
                value: `${config.aiProviderName}/${config.owner}/${config.name}`,
                text: config.label
            }))
    );

    const getDefaultModelByType = computed(() => (type: string): AiModelSettings | undefined =>
    {
        if (!aiModels.value) return undefined;

        // Czy istnieje model oznaczony jako domyślny
        const defaultModel = aiModels.value.find(m => m.type === type && m.isDefault);

        if (defaultModel) return defaultModel;

        // Jeśli nie, zwróć pierwszy model tego typu
        return aiModels.value.find(m => m.type === type);
    });

    function loadAiSettings()
    {
        AiSettingsService.getSettings()
            .then((data) =>
            {
                aiSettings.value = data;
            })
            .catch((error) =>
            {
                // eslint-disable-next-line no-console
                console.log(error);
            });
    }

    async function reload()
    {
        await loadAiSettings();
    }

    reload();

    return { aiSettings, aiEnabled, aiModelOptions, aiProviderOptions, getDefaultModelByType, reload };
});
